export enum CashbackStatusEnum {
    AGUARDANDO = 'aguardando',
    EM_LIBERACAO = 'liberacao',
    REPROVADO = 'reprovado',
    LIBERADO = 'liberado',
    SOLICITADO = 'solicitado',
    PAGO = 'pago'
}